<template lang="pug">
  ShowcaseLayout(
    :title='$route.meta.title'
    :slots='["tracks", "albums", "artists"]'
  )
    template(
      slot='tracks'
    )
      Showcase(
        :title='$l10n("TRACKS")'
        type='tracks'
        key='tracks'
        url='tracks/favorite'
        :empty-message='$l10n("TRACKLIST_IS_EMPTY")'
        :items='favoriteTracks'
      )
    template(
      slot='albums'
      v-if='favoriteAlbums.length'
    )
      Showcase(
        :title='$l10n("ALBUMS")'
        type='albums'
        key='albums'
        url='albums/favorite'
        :items='favoriteAlbums'
      )
    template(
      slot='artists'
      v-if='favoriteArtists.length'
    )
      Showcase(
        :title='$l10n("ARTISTS")'
        type='artists'
        key='artists'
        url='artists/favorite'
        :items='favoriteArtists'
      )
</template>

<script>
import PageLoader from "@/services/pageLoader";
import showcasePage from "@/mixins/pages/showcase.mixin";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";
import { ITEMS_IN_SHOWCASE } from "@/constants";

const strategy = async function(route, ctx) {
  try {
    const {
      tracks: favoriteTracks = []
    } = await PageLoader.getFavoriteTracks();

    ctx.favoriteTracksIds = favoriteTracks.map(track => track.id);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const {
      albums: favoriteAlbums = []
    } = await PageLoader.getFavoriteAlbums();

    ctx.favoriteAlbumsIds = favoriteAlbums.map(track => track.id);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const {
      artists: favoriteArtists = []
    } = await PageLoader.getFavoriteArtists();

    ctx.favoriteArtistsIds = favoriteArtists.map(track => track.id);
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "FavoritesPage",
  mixins: [
    showcasePage(strategy, {
      sections: ["favoriteTracksIds", "favoriteAlbumsIds", "favoriteArtistsIds"]
    })
  ],
  data() {
    return {
      favoriteTracksIds: [],
      favoriteAlbumsIds: [],
      favoriteArtistsIds: []
    };
  },
  computed: {
    ...mapGetters({
      tracks: "tracks/tracks",
      albums: "albums/albums",
      artists: "artists/artists"
    }),
    favoriteTracks() {
      return this.favoriteTracksIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map(id => this.tracks[id]);
    },
    favoriteAlbums() {
      return this.favoriteAlbumsIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map(id => this.albums[id]);
    },
    favoriteArtists() {
      return this.favoriteArtistsIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map(id => this.artists[id]);
    }
  }
};
</script>
